export interface CalendarDowntime {
  id?: number;
  startDate: string;
  endDate: string;
  comment: string;
  deleted?: boolean;
}

export function getActiveDowntimes(downtimes: CalendarDowntime[] = [], date: string): CalendarDowntime[] {
  return downtimes.filter((item) => !item.deleted && item.startDate <= date && item.endDate >= date);
}

export function getDowntimeKey(downtimes: CalendarDowntime[] = [], date: string): string {
  // Include the interval for entries without a persisted ID, and all active
  // intervals so that overlapping downtimes also split the rendered block.
  return JSON.stringify(getActiveDowntimes(downtimes, date)
    .map((item) => JSON.stringify([item.id, item.startDate, item.endDate, item.comment]))
    .sort());
}
